import React from "react";
import QRCode from "qrcode";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from "../labReport/labReport.module.scss";
// import qrcode from "../../../images/qr.png";
// import headerLogo from "./Picture1.png";
// import isoLogo from "./Picture2.jpg";
// import waterMarkLogo from "./Picture4.png";
// import signaturekLogo from "./Picture5.jpg";
import TataReport from "../Template/tataReport/tatareport";
import tataVoucherPrint from "../Template/tataReport/tataVoucherPrient";
import DefaultReport from "../Template/DefaultReport/DefaultReport";
import defaultVoucherPrint from "../Template/DefaultReport/defaultVoucherPrint";
import CurewellReport from "../Template/CurewellReport/Curewell";
import curewellVoucherPrint from "../Template/CurewellReport/CurewellVoucherPrint";
import { useLocation } from "react-router-dom";

const PaymentVoucher = () => {
  const { commissionId, paymentDetailsId } = useParams();
  const location = useLocation();
  const clinicId = location.state?.clinicId;
  const referrerId = location.state?.referrerId;
  const selectedItem = location.state?.selectedItem; // now you can see the clicked item
  const servicePaymentDetails = location.state?.servicePaymentDetails;
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinic = clinicInfo && clinicInfo?.length > 0 ? clinicInfo[0] : [];
  const reportName = clinic?.reportName || "default";
  const address = `
    ${clinic?.clinicAddress?.plot ? `${clinic.clinicAddress.plot}, ` : ""}
    ${clinic?.clinicAddress?.area ? `${clinic.clinicAddress.area}, ` : ""}
    ${clinic?.clinicAddress?.street ? `${clinic.clinicAddress.street}, ` : ""}
    ${
      clinic?.clinicAddress?.landMark
        ? `${clinic.clinicAddress.landMark}, `
        : ""
    }
    ${
      clinic?.clinicAddress?.city?.name
        ? `${clinic.clinicAddress.city.name}, `
        : ""
    }
    ${
      clinic?.clinicAddress?.state?.name
        ? `${clinic.clinicAddress.state.name}, `
        : ""
    }
    ${
      clinic?.clinicAddress?.country?.name
        ? `${clinic.clinicAddress.country.name}, `
        : ""
    }
    ${clinic?.clinicAddress?.pin ? clinic.clinicAddress.pin : ""}
  `.trim();

  // Render correct report UI
  let ReportComponent;
  switch (reportName) {
    case "tatareport":
      ReportComponent = TataReport;
      break;
    case "curewellreport":
      ReportComponent = CurewellReport;
      break;
    default:
      ReportComponent = DefaultReport;
  }

  const handlePrint = () => {
    const reportURL = `${window.location.origin}/payment_voucher/${commissionId}/${paymentDetailsId}`;

    QRCode.toDataURL(reportURL)
      .then((qrDataUrl) => {
        const extras = {
          address,
          watermark: clinic?.hospitalInfo?.waterMark || "",
          isoLogo: clinic?.hospitalInfo?.ISOLogo || "",
          footer: clinic?.hospitalInfo?.footer || "",
        };

        if (reportName === "tatareport") {
          tataVoucherPrint(clinic, qrDataUrl, selectedItem, referrerId, extras);
        } else if (reportName === "curewellreport") {
          curewellVoucherPrint(
            clinic,
            qrDataUrl,
            selectedItem,
            referrerId,
            extras,
            commissionId,
            paymentDetailsId,
            servicePaymentDetails
          );
        } else {
          defaultVoucherPrint(
            clinic,
            qrDataUrl,
            selectedItem,
            referrerId,
            extras
          );
        }
      })
      .catch((err) => {});
  };

  // const invoiceHeaderLeft = () => (
  //   <div className={styles.invoiceMainDiv}>
  //     <div className={styles.invoiceHeaderLeft}>
  //       <div className={styles.invoiceHeaderLogo}>
  //         <img src="/images/Picture1.png" alt="Header Logo" />
  //         <div>
  //           <h4>Address</h4>
  //           <p>{address}</p>
  //           <p>
  //             <span>Website :</span>
  //             {clinic?.hospitalInfo?.web_address}
  //           </p>
  //           <p>
  //             <span>Contact No :</span>
  //             {clinic?.phone}
  //           </p>
  //           <p>
  //             <span>GSTIN :</span>
  //             {clinic?.accountInfo?.gst}
  //           </p>
  //         </div>
  //       </div>
  //       <div className={styles.invoiceAdress}>
  //         <p>Address</p>
  //         <p>A-15 , Nayapallii Road ,Nayapalli near gothapatnann,752078</p>
  //         <p>
  //           <span>Name : </span>Simpleekare
  //         </p>
  //         <p>
  //           <span>Email : </span>Simpleekare@gmail.com
  //         </p>
  //         <p>
  //           <span>Phone : </span>9348745439
  //         </p>
  //       </div>
  //       <div className={styles.invoiceIsoLogo}>
  //         <img src="/images/Picture2.jpg" alt="ISO Logo" />
  //       </div>
  //     </div>
  //   </div>
  // );

  // const invoiceHeaderRight = () => (
  //   <div className={styles.invoiceMainDiv}>
  //     <div className={styles.invoiceHeaderRight}>
  //       <div className={styles.invoiceAdress}>
  //         <h4>Address</h4>
  //         <p>A-15 , Nayapallii Road ,Nayapalli near gothapatnann,752078</p>
  //         <p>
  //           <span>Name : </span>Simpleekare
  //         </p>
  //         <p>
  //           <span>Email : </span> Simpleekare@gmail.com
  //         </p>
  //         <p>
  //           <span>Phone : </span>9348745439
  //         </p>
  //       </div>
  //       <div className={styles.invoiceHeaderLogo}>
  //         <img src="/images/Picture1.png" alt="Header Logo" />
  //         <div>
  //           <p>{address}</p>
  //           <p>
  //             <span>Website :</span>
  //             {clinic?.hospitalInfo?.web_address}
  //           </p>
  //           <p>
  //             <span>Contact No :</span>
  //             {clinic?.phone}
  //           </p>
  //           <p>
  //             <span>GSTIN :</span>
  //             {clinic?.accountInfo?.gst}
  //           </p>
  //         </div>
  //       </div>
  //       <div className={styles.invoiceIsoLogo}>
  //         <img src="/images/Picture2.jpg" alt="ISO Logo" />
  //       </div>
  //     </div>
  //   </div>
  // );

  // const invoiceHeaderCenter = () => (
  //   <div className={styles.invoiceMainDiv}>
  //     <div className={styles.invoiceHeaderCenter}>
  //       <div className={styles.invoiceHeaderLogo}>
  //         <div className={styles.invoiceHeaderLogoImage}>
  //           <img src="/images/Picture1.png" alt="Header Logo" />
  //           <p>{address}</p>
  //           <p>
  //             <span>Website :</span>
  //             {clinic?.hospitalInfo?.web_address}
  //           </p>
  //           <p>
  //             <span>Contact No :</span>
  //             {clinic?.phone}
  //           </p>
  //           <p>
  //             <span>GSTIN :</span>
  //             {clinic?.accountInfo?.gst}
  //           </p>
  //         </div>
  //         <div className={styles.invoiceIsoLogo}>
  //           <img src="/images/Picture2.jpg" alt="ISO Logo" />
  //         </div>
  //       </div>
  //       <div className={styles.invoiceAdress}>
  //         <p>
  //           <span>Address</span> : Aurobinda Residency A-16
  //           Gothapatna,Bhubaneswar, <span>Name:</span>Shruti Behera{" "}
  //           <span>Email :</span> Shruti@gmail.com <span>Phone : 6766655</span>
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  // );

  // const invoiceHeaderFullWidth = () => (
  //   <div className={styles.invoiceMainDiv}>
  //     <div className={styles.invoiceHeaderFullwidth}>
  //       <div className={styles.invoiceHeaderLogo}>
  //         <div>
  //           <img
  //             src={headerLogo}
  //             alt="Header Logo"
  //             className={styles.invoiceHeaderLogoImage}
  //           />
  //         </div>
  //         <div>
  //           <h4>Address</h4>
  //           <p>{address}</p>
  //           <p>
  //             <span>Website :</span>
  //             {clinic?.hospitalInfo?.web_address}
  //           </p>
  //           <p>
  //             <span>Contact No :</span>
  //             {clinic?.phone}
  //           </p>
  //           <p>
  //             <span>GSTIN :</span>
  //             {clinic?.accountInfo?.gst}
  //           </p>
  //         </div>
  //         <div className={styles.invoiceIsoLogo}>
  //           <img src="/images/Picture2.jpg" alt="ISO Logo" />
  //         </div>
  //       </div>
  //       <div className={styles.invoiceAdress}>
  //         <p>
  //           <span>Address</span> : Aurobinda Residency A-16
  //           Gothapatna,Bhubaneswar, <span>Name:</span>Shruti Behera{" "}
  //           <span>Email :</span> Shruti@gmail.com <span>Phone : 6766655</span>
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  // );

  return (
    <>
      {reportName === "tatareport" && (
        <TataReport
          clinic={clinic}
          address={address}
          commissionId={commissionId}
          paymentDetailsId={paymentDetailsId}
          selectedItem={selectedItem} // clicked item
          referrer={referrerId}
          servicePaymentDetails={servicePaymentDetails}
        />
      )}
      {reportName === "curewellreport" && (
        <CurewellReport
          clinic={clinic}
          address={address}
          commissionId={commissionId}
          paymentDetailsId={paymentDetailsId}
          selectedItem={selectedItem} // clicked item
          referrer={referrerId}
          servicePaymentDetails={servicePaymentDetails}
        />
      )}
      {reportName === "default" && (
        <DefaultReport
          clinic={clinic}
          address={address}
          commissionId={commissionId}
          paymentDetailsId={paymentDetailsId}
          selectedItem={selectedItem} // clicked item
          referrer={referrerId}
          servicePaymentDetails={servicePaymentDetails}
        />
      )}
      <div className="text-center my-4" style={{ marginTop: "1rem" }}>
        <button className="btn btn-primary" onClick={handlePrint}>
          Print & Download
        </button>
      </div>
    </>
  );
};

export default PaymentVoucher;
